import { render, staticRenderFns } from "./ProduceMng.vue?vue&type=template&id=80033122&"
import script from "./ProduceMng.vue?vue&type=script&lang=js&"
export * from "./ProduceMng.vue?vue&type=script&lang=js&"
import style0 from "./ProduceMng.vue?vue&type=style&index=0&id=80033122&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports